$(function() {
    var $dVehicleTabs = $('#desktop-main').find('.vehicle-tabs');
    var $dVehicleTabsContent = $dVehicleTabs.find('.tab-body');
    var desktopVehicleDimension = '.vstep-select-header';
    var desktopVehicleOptions = '.vstep-select-options';

    const $toggleAttr = (el, attrName) => {
        $(el).attr(attrName, !$(el).attr(attrName));
    }

    // When one of the content body shows, pre-populate the form.
    $dVehicleTabsContent.on('show.bs.collapse', function(e) {
        var $tab = $(e.target);
        
        if (! $tab.hasClass('tab-body'))
        {
            // Inner collapse was clicked on so don't do this.
            return;
        }
        
        // Always reset step back to one when tab is switched.
        var $form = $tab.find('.vehicle-select-form');
        var stepValue = $tab.data('step-value');
        
        // Reset form from previous selections.
        VehicleSelector.resetSteps();
        resetVehicleForm($form);
        
        // Form step array (in this case, it's one index)
        VehicleSelector.addStep(1, stepValue);
        
        // Build form.
        VehicleSelector.getNextStep(function(data) {
            buildVehicleForm($form, data);
        });
    });

    // When a dropdown is toggled in vehicle selector on desktop.
    $dVehicleTabsContent.on('show.bs.collapse', desktopVehicleOptions, function(e) {
        // Toggle any open ones back up.
        $dVehicleTabsContent.find(desktopVehicleOptions).filter('.show').collapse('hide');
        var $vstep = $(this).parents('.vstep-select').children(desktopVehicleDimension);
        $toggleAttr($vstep, 'aria-expanded');
    });

    $dVehicleTabsContent.on('shown.bs.collapse', desktopVehicleOptions, function(e) {
        var $vstep = $(this).parents('.vstep-select').children(desktopVehicleDimension);
    });
    
    // When a dropdown is slid up in vehicle selector on desktop.
    $dVehicleTabsContent.on('hide.bs.collapse', desktopVehicleOptions, function(e) {
        var $vstep = $(this).parents('.vstep-select').children(desktopVehicleDimension);
        $toggleAttr($vstep, 'aria-expanded');
    });
    
    // When a select value is changed inside the make tab.
    $dVehicleTabsContent.on('click', desktopVehicleOptions + ' .vehicle-option', function(e) {
        var $option = $(this);
        var $select = $option.parents('.vstep-select');
        var $form = $select.parents('.vehicle-select-form');
        
        // See what option they clicked and what step it belongs to.
        var vstep = $option.data('step');
        var value = $option.data('key');
        
        // Slide this vstep up now that they chose an option.
        $select.find(desktopVehicleOptions).collapse('hide');
        // Change the label name of it.
        $select.find(desktopVehicleDimension + ' > span').html($option.html());
        
        // Remove every other step after this one.
        var $removeVSteps = $select.nextAll();
        
        // Remove these from the form.
        $.each($removeVSteps, function(index, step) {
            var $step = $(step);
            
            VehicleSelector.removeStep($step.data('vstep'));
            
            // Now remove the actual wrapper.
            $step.remove();
        });
        
        // Remove the input for this step (but not the wrapper)
        VehicleSelector.removeStep(vstep);
        
        // Add thie new value for this step.
        VehicleSelector.addStep(vstep, value);
        
        // Make the request.
        VehicleSelector.getNextStep(function(data) {
            buildVehicleForm($form, data);
        });
    });
    
    // Pagination on click events.
    $dVehicleTabsContent.on('click', '.change-page', function(e) {
        e.preventDefault();
        var $btn = $(this);
        var $select = $btn.parents(desktopVehicleOptions);
        var currentPage = parseInt($select.data('current-page'), 10);
        var page = $btn.data('pageto');
        
        if (page == 'prev') {
            page = currentPage - 1;
        } else if (page == 'next') {
            page = currentPage + 1;
        }
        
        changeVehicleSelectorPage($select, parseInt(page, 10));
    });
    
    /**
     * Change page in vehicle selector options.
     *
     * @param DOMElement select
     * @param int        page
     *
     * @return void
     */
    function changeVehicleSelectorPage(select, page) {
        var totalPages = select.data('total-pages');
        var $pagination = select.find('.pagination');
        var $leftArrow = $pagination.find('.page-arrow[data-pageto="prev"]');
        var $rightArrow = $pagination.find('.page-arrow[data-pageto="next"]');
        
        // Hide active pages.
        select.find('.page').not('.d-none').addClass('d-none');
        
        // Show page they want to navigate to.
        select.find('.page[data-page="' + page + '"]').removeClass('d-none');
        
        // Update buttons.
        select.data('current-page', page);
        $pagination.find('.page-item.active').removeClass('active');
        $pagination.find('.page-item[data-pageto="' + page + '"]').addClass('active');
        
        // If page = 1, hide left arrow.
        if (page == 1) {
            $leftArrow.addClass('d-none');
            $rightArrow.removeClass('d-none');
        } else if (page == totalPages) {
            // Last page, hide the right arrow.
            $rightArrow.addClass('d-none');
            $leftArrow.removeClass('d-none');
        } else {
            // Show both arrows.
            $pagination.find('.page-arrow').removeClass('d-none');
        }
    }
    
    /**
     * Submit vehicle selector form.
     *
     * @param DOMElement form
     *
     * @return void
     */
    function submitVehicleForm(form) {
        var steps = [];
        
        // Put the steps in a format the template can understand (key and value don't seem to work for some reason)
        $.each(VehicleSelector.getSteps(), function(step, value) {
            steps.push({
                key: step,
                value: value
            });
        });
        
        form.find('.form-fields').html(Jemplate.process('includes/partials/vehicle-hidden-form-steps.html', {
            steps: steps
        }));
        
        form.submit();
    }
    
    /**
     * Reset vehicle selector form.
     *
     * @param DOMElement form
     * 
     * @return void
     */
    function resetVehicleForm(form) {
        // Remove all previous select options.
        form.find('.options').children().remove();
        
        // Remove hidden input fields
        form.find('.form-fields').html('');
    }
    
    /**
     * Build the vehicle select form.
     *
     * @param DOMElement form (The form to build the select boxes in)
     * @param mixed      data
     *
     * @return void
     */
    function buildVehicleForm(form, data) {
        // Build the form!
        var $options = form.find('.options');
        var $actions = form.find('.actions');

        if (data.length === 0) {
            // End of vehicle selection options so let's enable submit the form.
            submitVehicleForm(form);
            return;
        }
        
        // There are more options so let's loop through them and create our select boxes.
        var lastStep = data[data.length - 1].key; // Need this to store the last select for event trigger if it's the last default option.
        $.each(data, function(index, step) {
            // Build dropdown
            var templateOptions = {
                step: step.key.split('_')[1],
                label: step.label,
                options: step.options,
                isDisabled: false
            };
            
            // Let's check if this step only has one options.
            if (step.options.length == 1) {
                // Set a default value!
                templateOptions.label = step.options[0].label;
                templateOptions.value = step.options[0].val;
                templateOptions.options = []; // Remove options since it only has one
                templateOptions.isDisabled = true;
                
                // Put these in the form.
                VehicleSelector.addStep(templateOptions.step, templateOptions.value);
            }
            
            templateOptions.perPage = 40;
            templateOptions.currentPage = 1;
            templateOptions.pages = Math.ceil(step.options.length / templateOptions.perPage);
            
            var $dropdown = Jemplate.process('includes/partials/vehicle-selector-dropdown.html', templateOptions);
            
            // Now append dropdown to form options.
            $options.append($dropdown);
            
            // If it's the last select box in the form and is disabled, trigger the change event.
            if (step.key === lastStep && templateOptions.isDisabled) {
                // Build steps object.
                VehicleSelector.addStep(templateOptions.step, templateOptions.value);
                
                // Make the request.
                VehicleSelector.getNextStep(function(data) {
                    buildVehicleForm(form, data);
                });
            }
        });

        if ( VehicleSelector.stepsToSelect.length ) {
            var nextStepValue = VehicleSelector.stepsToSelect.shift();
            $options.find( '.vehicle-option' ).each( ( i, option ) => {
                var $option = $( option );
                if ( $option.text() === nextStepValue.toString() ) {
                    $option.click();
                    return false;
                }
            } );
        }
    }
});
